import React from "react";

interface DeductionCommentBadgeProps {
  comment?: string;
}

const DeductionCommentBadge: React.FC<DeductionCommentBadgeProps> = ({ comment }) => {
  if (!comment?.trim()) return null;

  const trimmed = comment.trim();
  const shortText = trimmed.length > 32 ? `${trimmed.slice(0, 32).trim()}...` : trimmed;

  return (
    <div
      className="mt-1 inline-flex max-w-full rounded-full bg-amber-100 px-2.5 py-1 text-xs text-amber-800"
      title={trimmed}
    >
      <span className="truncate">{shortText}</span>
    </div>
  );
};

export default DeductionCommentBadge;